import { rangePresets, defaultRangePreset } from '@gogame/intl-ts';
import { object, array, string, number, ref } from '@gogame/schemas';

import {
  FILTER_PERIOD,
  FILTER_MANAGERS,
  FILTER_USERS,
  FILTER_PAGE,
  FILTER_TYPE,
  GA_FILTER_PERIOD,
} from '../constants';

export const EMPTY_FILTERS = {
  [FILTER_PERIOD]: rangePresets.LAST_7_DAYS.value,
};

export const filtersSchema = object({
  [FILTER_PERIOD]: array(string()).constants(defaultRangePreset),
  [FILTER_MANAGERS]: array(number()),
  [FILTER_USERS]: array(number()),
  [FILTER_PAGE]: number(),
  [FILTER_TYPE]: number(),
}).default({
  [FILTER_PERIOD]: rangePresets.LAST_7_DAYS.value,
});

export const filtersGaSchema = filtersSchema.shape({
  [GA_FILTER_PERIOD]: ref(FILTER_PERIOD, (value) => {
    return array(string())
      .constants(defaultRangePreset)
      .cast(value, { applyConst: true });
  }),
});
